import { useState } from 'react'

export default function TTSPage() {
  const [text, setText] = useState('')
  const [voice, setVoice] = useState('zh-CN-Xiaoxiao')
  const [speed, setSpeed] = useState(1)

  const voices = ['zh-CN-Xiaoxiao', 'zh-CN-Yunxi', 'zh-CN-Xiaoyi']

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎙?文字转语?</h2>

      <div style={{ background: '#fff', borderRadius: 8, padding: 24, maxWidth: 800 }}>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: 8, color: '#999', fontSize: 13 }}>输入文字</label>
          <textarea value={text} onChange={e => setText(e.target.value)} placeholder="输入要转换的文字..." style={{ width: '100%', height: 120, padding: 12, border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, resize: 'none' }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 20 }}>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#999', fontSize: 13 }}>音色</label>
            <select value={voice} onChange={e => setVoice(e.target.value)} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14 }}>
              {voices.map(v => <option key={v} value={v}>{v}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, color: '#999', fontSize: 13 }}>语? {speed}</label>
            <input type="range" min="0.5" max="2" step="0.1" value={speed} onChange={e => setSpeed(e.target.value)} style={{ width: '100%' }} />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 12 }}>
          <button style={{ padding: '12px 24px', background: '#fff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>生成语音</button>
          <button style={{ padding: '12px 24px', background: '#fff', color: '#666', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>试听</button>
        </div>
      </div>
    </div>
  )
}
